// components/blogs/BlogCardView.tsx
"use client";
import React, { useEffect } from "react";
import { useState } from "react";
import Link from "next/link";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import toast, { Renderable, Toast, Toaster, ValueFunction } from "react-hot-toast";
import { AxiosPost } from "@/utilities/axioscall";
import { AK } from "@/constants";
import { FadeLoader } from "react-spinners";
import { lowercasenosp } from "@/utilities/checker";

interface BlogItem {
  id: number;
  storeid: number;
  sort_order: number;
  category_id: number | null;
  status: number;
  title: string;
  short_content: string;
  content: string;
  image: string;
  created_at: string;
  slug: string;
}

interface BlogCardViewProps {
  BlogData: BlogItem[];
}

const BlogCardView: React.FC<BlogCardViewProps> = ({ BlogData }) => {
  // Function to strip HTML tags (client-side safe)
  function stripHTMLTags(html: string) {
    if (!html) return "No description available.";

    // Client-side only
    if (typeof window !== "undefined" && typeof DOMParser !== "undefined") {
      try {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.body.textContent || "No description available.";
      } catch {
        return html.replace(/<[^>]+>/g, "") || "No description available.";
      }
    }

    // SSR-safe fallback (no DOMParser)
    return html.replace(/<[^>]+>/g, "") || "No description available.";
  }


  const [formValues, setFormValues] = useState({
    newsemail: "",
    newsemailError: false,
    formloading: false,
  });

  const handleSubmit = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    var error = false;

    if (formValues.newsemail === "") {
      handleChange({ target: { value: true, name: "newsemailError" } });
      error = true;
    } else {
      handleChange({ target: { value: false, name: "newsemailError" } });
    }

    if (error) return;
    console.log(formValues);

    handleChange({ target: { value: true, name: "formloading" } });
    var formdata = { email: formValues.newsemail };
    return await AxiosPost(AK.NEWSLETTERFORMAPI, formdata)
      .then((res: any) => {
        if (res?.data) {
          notify();
          setFormValues({
            newsemail: "",
            newsemailError: false,
            formloading: false,
          });
          handleChange({ target: { value: false, name: "formloading" } });
          return true;
        } else {
          notifyerror("Newsletter validation error.");
        }
        handleChange({ target: { value: false, name: "formloading" } });
        return true;
      })
      .catch((error) => {
        console.log("error", error);
        let errorMessage = "Newsletter validation error.";
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errorMessage = error.response.data.message;
            if (error.response.data.errors && typeof error.response.data.errors === "object") {
              const validationErrors = Object.values(error.response.data.errors)
                .flat()
                .join(", ");
              errorMessage += `: ${validationErrors}`;
            }
          }
        }
        notifyerror(errorMessage);
        handleChange({ target: { value: false, name: "formloading" } });
        return false;
      });
  };

  const handleChange = (e: { target: any }) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const notify = () =>
    toast.success("Newsletter subscribed successfully.", {
      style: {
        border: "1px solid #00b852",
        padding: "16px",
        color: "#00b852",
        zIndex: "10000 !important",
      },
      iconTheme: {
        primary: "#00b852",
        secondary: "#FFFAEE",
      },
    });

  const notifyerror = (msg: Renderable | ValueFunction<Renderable, Toast>) =>
    toast.error(msg, {
      style: {
        border: "1px solid #cc0000",
        padding: "16px",
        color: "#cc0000",
        zIndex: "10000 !important",
      },
      iconTheme: {
        primary: "#cc0000",
        secondary: "#FFFAEE",
      },
    });

  console.log("blogData", BlogData);

  return (
    <>
      <div className="mx-auto max-w-7xl py-12">
        <div className="flex flex-col md:flex-row gap-8">
          <div
            className="md:w-2/3 w-full overflow-x-hidden"
            style={{
              scrollbarWidth: "thin",
              scrollbarColor: "#888 #fff",
            }}
          >
            <div className="px-4 py-2 cursor-pointer font-['Alice'] md:text-lg rounded-md transition-all duration-300 bg-white text-black text-3xl font-bold">
              Our Blogs
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 px-4 md:px-0 gap-4 py-2 md:py-8">
              {Array.isArray(BlogData) && BlogData.length > 0 ? (
                BlogData.map((item: any, index: number) => (
                  <div key={index}>
                    <a href={`/blog/${item.slug}`} className="no-underline">
                      <div className="bg-white rounded-md p-1 mb-4 hover:shadow-lg transition-shadow duration-300">
                        <img
                          src={
                            item.image
                              ? `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/ZE17R3051024/${item.image}`
                              : "/ecomsaas-assets/images/no-image.webp"
                          }
                          alt={item.title || "Recent"}
                          className="w-full h-[200px] object-cover rounded-md"
                          onError={(e) => {
                            e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                          }}
                        />
                        <h2 className="text-black font-['Alice'] text-xl md:text-2xl leading-7 mt-2 mb-2">
                          {item.title || "No Title Available"}
                        </h2>
                        <p className="text-black font-['Alice'] text-base md:text-lg leading-6 mb-1">
                          {stripHTMLTags(item.short_content)?.length > 160
                            ? stripHTMLTags(item.short_content).slice(0, 160) + "..."
                            : stripHTMLTags(item.short_content) || "No description available."}
                        </p>
                        <div className="flex justify-between items-center">
                          <a
                            href={`/blog/${item.slug}`}
                            className="bg-[#F2F7E0] text-primary font-['Alice'] text-base md:text-lg px-2 py-1 rounded-md no-underline"
                          >
                            Read More..
                          </a>
                          <h6 className="text-primary font-['Alice'] text-xs md:text-sm mb-0">
                            {item.created_at
                              ? new Date(item.created_at).toLocaleDateString("en-US", {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                              })
                              : "No Date Available"}
                          </h6>
                        </div>
                      </div>
                    </a>
                  </div>
                ))
              ) : (
                <div className="flex justify-center items-center w-full">
                  <img
                    className="mx-auto"
                    style={{ width: "150px" }}
                    src={`/ecomsaas-assets/loader/sandprocess.gif`}
                    alt={`${lowercasenosp("store")} loader`}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="md:w-1/3 w-full">
            <div className="bg-[#FBFFD9] rounded-xl p-6 md:p-10 sticky top-24">
              <div className="text-center">
                <h1 className="text-[#3A3A3A] font-['Alice'] text-xl md:text-2xl">
                  SIGN UP FOR NEWSLETTER
                </h1>
                <h2 className="text-[#3A3A3A] font-['Alice'] text-sm md:text-base py-2 md:pb-8">
                  Subscribe to the newsletter for all the latest updates
                </h2>
                <input
                  id="newsemail"
                  name="newsemail"
                  value={formValues.newsemail}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Mail"
                  aria-label="Recipient's username"
                  aria-describedby="button-addon2"
                  className="w-full border border-[#DEE2E6] rounded-md px-5 py-3 text-base"
                />
                <FadeLoader
                  loading={formValues.formloading}
                  width={"2px"}
                  height={"10px"}
                  color="#86BC42"
                />
                <p
                  className={`text-red-500 mt-2 ${formValues.newsemailError ? "block" : "hidden"}`}
                >
                  Please enter your email.
                </p>
                <button
                  id="button-addon2"
                  onClick={(e) => handleSubmit(e)}
                  type="button"
                  className="w-full !bg-primary text-[#F5F5DC] font-['Alice'] text-base md:text-lg rounded-md border border-[#849D6A] py-3 mt-4 mb-10"
                >
                  SUBSCRIBE
                </button>
                <div className="flex justify-center gap-8">
                  <a
                    href="https://www.facebook.com/people/Thaithingal-Essentials/61558061902003/"
                    aria-label="Visit Our Facebook Page"
                    target="_blank"
                  >
                    <FaFacebookF className="text-primary text-2xl" />
                  </a>
                  <a
                    href="https://twitter.com/thaithingal/"
                    target="_blank"
                    aria-label="Visit Our Twitter Page"
                  >
                    <FaXTwitter className="text-primary text-2xl" />
                  </a>
                  <a
                    href="https://www.instagram.com/thaithingal_/"
                    target="_blank"
                    aria-label="Visit Our Instagram Page"
                  >
                    <FaInstagram className="text-primary text-2xl" />
                  </a>
                  <a
                    href="https://www.youtube.com/@ThingalEssentials"
                    target="_blank"
                    aria-label="Visit Our Youtube Page"
                  >
                    <FaYoutube className="text-primary text-2xl" />
                  </a>
                </div>
                <Toaster
                  toastOptions={{
                    style: { zIndex: 100000 },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .overflow-x-hidden::-webkit-scrollbar {
          width: 3px;
        }
        .overflow-x-hidden::-webkit-scrollbar-track {
          background-color: #fff;
        }
        .overflow-x-hidden::-webkit-scrollbar-thumb {
          background-color: #888;
          border-radius: 4px;
        }
        .overflow-x-hidden::-webkit-scrollbar-thumb:hover {
          background-color: #555;
        }
        @media (max-width: 768px) {
          .overflow-x-auto {
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
        }
      `}</style>
    </>
  );
};

export default BlogCardView;